document.addEventListener("DOMContentLoaded", () => {
  const categoryButtons = document.querySelectorAll(".faq-category-toggle");
  const shortAnswerButtons = document.querySelectorAll(".faq-short-answer");
  const allRightPanels = document.querySelectorAll(".faq-right-group");
  const faqImage = document.querySelector(".faq-image-wrapper");

  // CATEGORY TOGGLE (LEFT COLUMN) - SCROLL LOGIC REMOVED
  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const categoryEl = button.closest(".faq-category");
      const shortAnswers = categoryEl.querySelector(".faq-short-answers");
      const isOpen = categoryEl.classList.contains("open");

      // Close all other categories
      document.querySelectorAll(".faq-category").forEach((cat) => {
        if (cat !== categoryEl) {
          cat.classList.remove("open");
          const answers = cat.querySelector(".faq-short-answers");
          if (answers) answers.hidden = true;
        }
      });

      // Hide all right column content
      allRightPanels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove("active");
      });

      // Hide image
      if (faqImage) {
        faqImage.classList.remove("visible");
      }

      // Toggle just the current category
      if (!isOpen) {
        categoryEl.classList.add("open");
        if (shortAnswers) shortAnswers.hidden = false;
      } else {
        categoryEl.classList.remove("open");
        if (shortAnswers) shortAnswers.hidden = true;
      }
    });
  });

  // SHORT ANSWER CLICK - SCROLL LOGIC ADDED HERE
  shortAnswerButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      const categoryId = button.dataset.category;
      const shortId = button.dataset.short;

      if (button.id) {
        history.replaceState(null, null, `#${button.id}`);
      }

      // Hide all right panels
      allRightPanels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove("active");
      });

      // Show matching right panel
      const targetPanel = document.querySelector(
        `.faq-right-group[data-category="${categoryId}"][data-short="${shortId}"]`
      );

      if (targetPanel) {
        targetPanel.hidden = false;
        targetPanel.classList.add("active");

        const detailsEls = targetPanel.querySelectorAll("details");
        detailsEls.forEach((details, index) => {
          details.open = index === 0;

          const summary = details.querySelector("summary");
          summary.addEventListener("click", () => {
            detailsEls.forEach((other) => {
              if (other !== details) {
                other.open = false;
              }
            });
          });
        });

        // This runs after a sub-category is clicked.
        if (window.innerWidth < 750) {
          setTimeout(() => {
            targetPanel.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 150);
        }
      }

      // Show image
      if (faqImage) {
        faqImage.classList.add("visible");
      }
    });
  });

  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1);
    const targetButton = document.getElementById(targetId);

    if (targetButton && targetButton.classList.contains("faq-short-answer")) {
      const parentCategory = targetButton.closest(".faq-category");
      if (parentCategory && !parentCategory.classList.contains("open")) {
        const categoryToggle = parentCategory.querySelector('.faq-category-toggle');
        if (categoryToggle) categoryToggle.click();
      }
      targetButton.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => {
        targetButton.click();
        history.replaceState(null, null, window.location.pathname);
      }, 300);
    }
  }
});